import 'react-tooltip/dist/react-tooltip.css';
import React from 'react';

import Routes from 'routes';
import { GlobalComponentsContextProvider } from 'context/GlobalComponentsContext';
import { GeolocalizeStoreProvider } from 'pages/Geolocalize/store';
import { HeaderFiltersProvider } from 'context/GlobalFiltersContext';
import { AuthContextProvider } from 'context/AuthContext';
import { SocketIoProvider } from 'context/SocketIoContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CSSReset, CSSGlobal } from 'assets/styled/sheets/generic';
import Amplifique from 'components/Amplifique';
import VersionChecker from 'components/VersionChecker';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// Disponibilizar queryClient globalmente para limpeza de cache
if (typeof window !== 'undefined') {
  (window as any).queryClient = queryClient;
}
const LkpApp = () => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <CSSReset />
          <CSSGlobal />
          <VersionChecker />
          <AuthContextProvider>
            <GlobalComponentsContextProvider>
              <HeaderFiltersProvider>
                <GeolocalizeStoreProvider>
                  <SocketIoProvider>
                    <Routes />
                  </SocketIoProvider>
                </GeolocalizeStoreProvider>
                {process.env?.NODE_ENV !== 'development' && <Amplifique />}
              </HeaderFiltersProvider>
            </GlobalComponentsContextProvider>
          </AuthContextProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

export const App = Sentry.withProfiler(LkpApp);
